import { useReleaseNotes } from "./use-release-notes";

import type { FC } from "react";

export const ReleaseNotes: FC = () => {
  useReleaseNotes();

  return null;
};
